import { render } from "./TableListConfig.vue?vue&type=template&id=1ebc9116&ts=true"
import script from "./TableListConfig.vue?vue&type=script&lang=ts"
export * from "./TableListConfig.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__